import { render, staticRenderFns } from "./audioBtn.vue?vue&type=template&id=066e6592&scoped=true"
import script from "./audioBtn.vue?vue&type=script&lang=js"
export * from "./audioBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e6592",
  null
  
)

export default component.exports